import { useEffect, useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { PrimaryTitleGray } from '../../../app/theme/tokens/colors';
import { TextAreaInput } from '../../../shared/ui/Inputs';
import { ImageSlider } from '../../../shared/media/slider';
import { saveCollectionOrder } from '../../../services/collection/collectionService';
import { getProductsImages } from '../../../services/products/productService';
import { usePortalStore } from '../../../stores/portalStore';
import { useCollectionStore } from '../store/collectionStore';
import { DefaultFinishOrder } from '../../orders/usecases/finish/defaultFinishOrder';
import { getBase64Img } from '../../../utils/format';
import { isGenericOrder } from '../../../utils/orders';
import { GiHandTruck } from 'react-icons/gi';
import { groupBySegment } from './collection';

export const FinishCollectionOrder = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const currentUser = usePortalStore((state) => state.currentUser);
    const configuredCollections = useCollectionStore(
        (state) => state.configuredCollections
    );
    const selectedPatient = useCollectionStore((state) => state.selectedPatient);
    const getKeptItems = useCollectionStore((state) => state.getKeptItems);
    const [image, setImage] = useState([]);
    const [techDetails, setTechDetails] = useState('');
    const setCurrentAlertError = usePortalStore(
        (state) => state.setCurrentAlertError
    );
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedPatient?.cpf) {
            navigate('/collectEquipments/collectFromPatient');
            return;
        }
        if (
            !Array.isArray(configuredCollections) ||
            configuredCollections.length === 0
        ) {
            navigate('/collectEquipments/collectEquipments');
        }
    }, [selectedPatient, configuredCollections, navigate]);

    useEffect(() => {
        if (
            !selectedPatient?.cpf ||
            !Array.isArray(configuredCollections) ||
            configuredCollections.length === 0
        ) {
            return;
        }

        (async () => {
            const img = await getProductsImages(
                configuredCollections
                    .map((x) => [x.id, ...(x.accessories ?? []).map((y) => y.id)])
                    .flat()
            );
            setImage([...img]);
        })();
    }, [selectedPatient?.cpf, configuredCollections]);

    if (
        !selectedPatient?.cpf ||
        !Array.isArray(configuredCollections) ||
        configuredCollections.length === 0
    ) {
        return null;
    }
    const finalCollect = {};

    configuredCollections.forEach((parent) => {
        if (!finalCollect[parent.id]) {
            finalCollect[parent.id] = {
                product_code: parent.id,
                product_unit_value: 0,
                quantity_volume: parseInt(parent.qty),
            };
            parent.accessories.forEach((acc) => {
                if (!finalCollect[acc.id]) {
                    finalCollect[acc.id] = {
                        product_code: acc.id.toString(),
                        product_unit_value: 0,
                        quantity_volume: parseInt(acc.qty),
                    };
                } else {
                    finalCollect[acc.id.toString()].quantity_volume += 1;
                }
            });
        }
    });
    const finishOrder = async (deliveryDate, deliveryTurn) => {
        const hasGenericOrder = () => {
            return getKeptItems().some(
                (x) => x.collect === true && isGenericOrder(x.id)
            );
        };
        if (techDetails === '' && hasGenericOrder()) {
            setCurrentAlertError(
                'Por favor, insira ao menos uma informação para continuar com o pedido.'
            );
            return null;
        }
        const orderNumber = await saveCollectionOrder(
            currentUser,
            selectedPatient.cnpj,
            selectedPatient,
            finalCollect,
            deliveryDate,
            techDetails,
            deliveryTurn
        );
        if (orderNumber === null) {
            setCurrentAlertError(
                `Filial não encontrada para a cidade ${selectedPatient.city}`
            );
        }
        return orderNumber;
    };
    const topTile = () => {
        return (
            <div
                style={{
                    display: isTabletOrMobile ? 'block' : 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <div style={{ flex: '1', minWidth: '400px', maxWidth: '400px' }}>
                    <ImageSlider images={image.map((x) => getBase64Img(x))}></ImageSlider>
                </div>
                <div style={{ marginLeft: '15px', width: '100%' }}>
                    {confirmChanges()}
                </div>
            </div>
        );
    };
    const confirmChanges = () => {
        const hasGenericOrder = () => {
            return getKeptItems().some(
                (x) => x.collect === true && isGenericOrder(x.id)
            );
        };

        return (
            <div style={{ position: 'relative', fontSize: '14px' }}>
                {/* <div>
                    <div style={{display:"flex",alignItems:"center",borderBottom: "solid 1px #ccc", marginBottom: "5px"}}>
                        <MdLocalHotel style={{fontSize:"25px",marginRight:"9px",color:"#318300"}}></MdLocalHotel> 
                        <div style={{fontSize: "16px"}}>Itens que serão mantidos</div>
                    </div>
                    <div>
                        <ul style={{margin:"0", padding:"0"}}>
                            {Object.values(groupBySegment(getKeptItems().filter(x => x.collect === false))).map((ss,idx)=>
                            <li style={{listStyle: "none"}} key={idx}>
                                <p>{ss.segment}</p>
                                {ss.data.map((acc,j)=><div style={{listStyle: "none",padding: "6px 15px",background: "#efefef",borderRadius: "10px",marginBottom: "5px",marginLeft: "35px"}} key={j}>{acc.name}</div>)}
                            </li>)}
                        </ul>
                    </div>
                </div> */}

                <div>
                    {hasGenericOrder() && (
                        <h4
                            style={{
                                marginTop: '0px',
                                color: 'black',
                                textTransform: 'uppercase',
                                fontSize: '18px',
                                fontWeight: '500',
                                borderBottom: 'solid 1px #a7a6a6',
                            }}
                        >
                            Validação e Processamento de Pedidos
                        </h4>
                    )}
                    {!hasGenericOrder() && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                borderBottom: 'solid 1px #ccc',
                                marginBottom: '5px',
                                marginTop: '10px',
                            }}
                        >
                            <GiHandTruck
                                style={{
                                    fontSize: '30px',
                                    marginRight: '9px',
                                    color: '#b34141',
                                }}
                            ></GiHandTruck>
                            {getKeptItems().filter(
                                (x) => x.collect === true && !isGenericOrder(x.id)
                            ).length > 1 ? (
                                <div style={{ fontSize: '16px' }}>
                                    Itens que serão recolhidos
                                </div>
                            ) : (
                                <div style={{ fontSize: '16px' }}>Item que será recolhido</div>
                            )}
                        </div>
                    )}
                    <div>
                        <ul style={{ margin: '0', padding: '0' }}>
                            {Object.values(
                                groupBySegment(
                                    getKeptItems().filter(
                                        (x) => x.collect === true && !isGenericOrder(x.id)
                                    )
                                )
                            ).map((ss, idx) => (
                                <li style={{ listStyle: 'none' }} key={idx}>
                                    <p>{ss.segment}</p>
                                    {ss.data.map((acc, j) => (
                                        <div
                                            style={{
                                                listStyle: 'none',
                                                padding: '6px 15px',
                                                background: '#efefef',
                                                borderRadius: '10px',
                                                marginBottom: '5px',
                                                marginLeft: '35px',
                                            }}
                                            key={j}
                                        >
                                            {acc.qty}x {acc.name}
                                        </div>
                                    ))}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    };
    const bottomTile = () => {
        return (
            <div style={{ width: '100%' }}>
                <h4
                    style={{
                        color: PrimaryTitleGray,
                        margin: '0px',
                        marginBottom: '10px',
                    }}
                >
                    Informações adicionais
                </h4>
                <TextAreaInput
                    onChange={(e) => setTechDetails(e.target.value)}
                    style={{ minWidth: '100%', minHeight: '120px', margin: '0px' }}
                ></TextAreaInput>
            </div>
        );
    };
    return (
        <DefaultFinishOrder
            topTileRender={topTile}
            bottomTileRender={bottomTile}
            selectedPatient={selectedPatient}
            onFinish={finishOrder}
            orderType={'Recolhimento'}
            fastDeliveryLabel={'Recolhimento imediato'}
            scheduleDeliveryLabel={'Recolhimento agendado'}
        ></DefaultFinishOrder>
    );
};
